<template>
  <div class="product-order__order ">
    <button 
      @click="(dropdownForm = true)"
      class="btn btn-primary order__btn order-btn">
      <i class="bi bi-bag-plus order-btn__icon order-btn__icon--cart">
      </i>&nbsp;В&nbsp;корзину
    </button>
    <button 
      class="btn btn-outline-primary order__btn"
      data-bs-toggle="modal"
      data-bs-target="#mainModal"
      data-bs-mtitle="Заказать прайс-лист"
      data-bs-mtext="Напишите, какая продукция и объем вас интересует. Расскажите о своей компании и потребностях, чтобы мы подготовили индивидуальный прайс-лист"
    >
      <i class="btn__icon btn__icon--excel">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-excel" viewBox="0 0 16 16">
            <path d="M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z"/>
            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
          </svg>
      </i>&nbsp;Прайс
    </button>
    <div class="dropdown-menu show product-order__dropdown product-order-menu" v-if="dropdownForm">
      <button 
        @click="(dropdownForm = false)"
        type="button" 
        class="btn btn-dark close product-order-menu__close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div v-if="step=='add-btn'">
        <div class="product-order-menu__title">Выбрать фасовку</div>
        <div class="order-form__form-group" v-bind:class="{ 'order-form__form-group--danger': errors.product }">
          <ul class="product-order-menu__variants product-variants" v-if="productInstance">
            <li 
              class="product-variants__item variant-radio" 
              v-bind:class="{'variant-radio--active' : (cartItem.object_id == variant.id)}" 
              v-on:click="set_cart_item(variant)"
              v-for="variant in productInstance.packages" 
              :key="'variant_'+variant.id">
              <label><input type="radio" v-model="cartItem.object_id" :value="variant.id" name="product_variants" class="product-variants__radio"> {{ variant.package_title }}</label>
            </li>
          </ul>
          <p class="order-form__help" v-if="errors.product">
            {{ errors.product.join(', ') }}
          </p>
        </div>
        <div class="product-order-menu__form order-form">
          <div class="order-form__form-group" v-bind:class="{ 'order-form__form-group--danger': errors.unit_quantity }">
            <label class="order-form__label">Количество:</label>
            <input type="text" v-model="cartItem.unit_quantity" class="order-form__input">
            <p class="order-form__help" v-if="errors.unit_quantity">
              {{ errors.unit_quantity.join(', ') }}
            </p>
          </div>
          <div class="order-form__buttons">
            <button 
              v-on:click="addToCartDropdown()"
              class="btn btn-info order-form__btn order-form__btn--add">В заказ</button>
          </div>
        </div>
      </div>
      <div v-if="step=='cart-btn'" class="dropdown-menu__result">
        <p class="text-success">Добавлено в корзину.</p>
        <div>
          <a href="/cart/" class="btn btn-primary me-1">Оформить</a>
          <button class="btn btn-dark ms-1" @click="(dropdownForm=false)">Закрыть</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import CartMixin from '../vue_mixins/CartMixin.vue'

export default {
  name: 'AddToCartPopupBtn',
  props: {
    appLabel: {
      type: String,
      default: null
    },
    contentType: {
      type: String,
      default: null
    },
    objectId: {
      type: Number,
      default: null
    },
    product: {
      type: Object,
      default: null
    }
  },
  mixins: [CartMixin],
  data() {
    return {
      step: 'add-btn',
      dropdownForm: false,
      productInstance: null,
      errors: {},
      cartItem: {
        unit_quantity: null,
        content_type: null,
        object_id: null
      }
    }
  },
  mounted () {
    if (this.product) {
      this.productInstance = this.product
    }
    if (!this.productInstance && this.contentType && this.objectId) {
      var params = {
        app_label: this.appLabel,
        content_type: this.contentType,
        object_id: this.objectId
      }
      axios.get("/cart/api/get-product/" + `?timestamp=${new Date().getTime()}`, {params: params}).then(response => {
        this.productInstance = response.data
      });
    }
  },
  methods: {
    set_cart_item: function (variant) {
      this.cartItem.object_id = variant.id
      this.cartItem.content_type = variant.content_type
      this.errors = {}
    }
  }
}
</script>

<style lang="scss">
</style>
